import down from "../../../assets/down.svg";
import up from "../../../assets/up.svg";
import "./style.css";
import { useEffect, useState } from "react";

export default function FAQ() {
  const [active, setActive] = useState("pills-general-tab");
  const [open, setOpen] = useState("one");

  useEffect(() => {
    setOpen("one");
  }, [active]);

  return (
    <div className="faq">
      <div className="tabSideBar">
        <ul
          className="nav nav-pills mb-3 faq-buttons"
          id="pills-tab"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <button
              className={`btn btn-label-tab ${
                active == "pills-general-tab" ? "btn-label-tab-active" : ""
              }`}
              onClick={() => {
                setActive("pills-general-tab");
              }}
              id="pills-general-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-general"
              type="button"
              role="tab"
              aria-controls="pills-general"
              aria-selected="true"
            >
              <span class="tab-label-text">General</span>
            </button>
          </li>
          {/* <li className="nav-item" role="presentation">
            <button
              className={`btn btn-label-tab ${
                active == "pills-pricing-tab" ? "btn-label-tab-active" : ""
              }`}
              onClick={() => {
                setActive("pills-pricing-tab");
              }}
              id="pills-pricing-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-pricing"
              type="button"
              role="tab"
              aria-controls="pills-pricing"
              aria-selected="false"
            >
              <span class="tab-label-text">Pricing</span>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`btn btn-label-tab ${
                active == "pills-support-tab" ? "btn-label-tab-active" : ""
              }`}
              onClick={() => {
                setActive("pills-support-tab");
              }}
              id="pills-support-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-support"
              type="button"
              role="tab"
              aria-controls="pills-support"
              aria-selected="false"
            >
              <span class="tab-label-text">Support and Resources</span>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`btn btn-label-tab ${
                active == "pills-security-tab" ? "btn-label-tab-active" : ""
              }`}
              onClick={() => {
                setActive("pills-security-tab");
              }}
              id="pills-security-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-security"
              type="button"
              role="tab"
              aria-controls="pills-security"
              aria-selected="false"
            >
              <span class="tab-label-text">Security and Privacy</span>
            </button>
          </li>
          <li className="nav-item" role="presentation">
            <button
              className={`btn btn-label-tab ${
                active == "pills-questions-tab" ? "btn-label-tab-active" : ""
              }`}
              onClick={() => {
                setActive("pills-questions-tab");
              }}
              id="pills-questions-tab"
              data-bs-toggle="pill"
              data-bs-target="#pills-questions"
              type="button"
              role="tab"
              aria-controls="pills-questions"
              aria-selected="false"
            >
              <span class="tab-label-text">Additional Questions</span>
            </button>
          </li> */}
        </ul>
      </div>

      <div className="tab-content newFaqTab" id="pills-tabContent">
        <div
          className={`tab-pane fade faq-section  ${
            active == "pills-general-tab" ? "show active" : ""
          }`}
          id="pills-general"
          role="tabpanel"
          aria-labelledby="pills-general-tab"
        >
          <div for="one">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer" style={{justifyContent:"space-between !important"}}
              onClick={() => setOpen(open == "one" ? "" : "one")}
            >
              <div className="off-black extra-large bold">
                What is Regul8, and how does it benefit CPG businesses?
              </div>

              {open == "one" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "one" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 is a software platform that leverages artificial
                intelligence to help CPG companies optimize their operations,
                manage regulatory compliance, and make data-driven decisions. It
                enhances supply chain efficiency, reduces costs, and improves
                responsiveness to market changes.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="two">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "two" ? "" : "two")}
            >
              <div className="off-black extra-large bold">
                How does Regul8 help with regulatory compliance in multiple
                markets?
              </div>

              {open == "two" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "two" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 monitors and analyzes regulatory changes across various
                markets and regions, providing real-time updates and automated
                alerts. It ensures your business remains compliant by tracking
                new requirements and streamlining compliance management
                processes.{" "}
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="three">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "three" ? "" : "three")}
            >
              <div className="off-black extra-large bold">
                What kind of consumer insights does Regul8 provide?
              </div>

              {open == "three" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "three" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 analyzes live consumer data to identify trends,
                preferences, and purchasing behavior. It provides actionable
                insights that help businesses tailor their marketing strategies,
                product development, and sales efforts to better meet consumer
                needs.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="four">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "four" ? "" : "four")}
            >
              <div className="off-black extra-large bold">
                Is Regul8 customizable to specific business needs?
              </div>

              {open == "four" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "four" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Absolutely. Regul8 offers customization options to fit the
                unique needs of different CPG businesses. It provides a seamless
                solution that aligns with your organizational goals.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="five">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "five" ? "" : "five")}
            >
              <div className="off-black extra-large bold">
                What types of reports can Regul8 generate?{" "}
              </div>

              {open == "five" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "five" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                The software can generate a variety of reports, including
                compliance status, risk assessments, supply chain performance,
                sales analytics, and consumer behavior insights. Reports are
                customizable and can be automated for regular updates.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="six">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "six" ? "" : "six")}
            >
              <div className="off-black extra-large bold">
                How does the AI in Regul8 help with risk management?
              </div>

              {open == "six" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "six" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 uses machine learning algorithms to identify potential
                risks in compliance, supply chain, and operations. It provides
                predictive insights and proactive risk mitigation strategies to
                help businesses avoid disruptions.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="seven">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "seven" ? "" : "seven")}
            >
              <div className="off-black extra-large bold">
                What support and training are provided when implementing Regul8?
              </div>

              {open == "seven" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "seven" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low ">
                Regul8 offers comprehensive support and training for new users,
                including onboarding sessions, user guides, and 24/7 customer
                support to ensure a smooth implementation and ongoing usability
                of the platform.{" "}
              </div>
            ) : null}
          </div>
        </div>

        <div
          className={`tab-pane fade faq-section ${
            active == "pills-pricing-tab" ? "show active" : ""
          }`}
          id="pills-pricing"
          role="tabpanel"
          aria-labelledby="pills-pricing-tab"
        >
          <div for="one">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "one" ? "" : "one")}
            >
              <div className="off-black extra-large bold">
                What is Regul8, and how does it benefit CPG businesses?
              </div>

              {open == "one" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "one" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 is a software platform that leverages artificial
                intelligence to help CPG companies optimize their operations,
                manage regulatory compliance, and make data-driven decisions. It
                enhances supply chain efficiency, reduces costs, and improves
                responsiveness to market changes.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="two">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "two" ? "" : "two")}
            >
              <div className="off-black extra-large bold">
                How does Regul8 help with regulatory compliance in multiple
                markets?
              </div>

              {open == "two" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "two" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 monitors and analyzes regulatory changes across various
                markets and regions, providing real-time updates and automated
                alerts. It ensures your business remains compliant by tracking
                new requirements and streamlining compliance management
                processes.{" "}
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="three">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "three" ? "" : "three")}
            >
              <div className="off-black extra-large bold">
                What kind of consumer insights does Regul8 provide?
              </div>

              {open == "three" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "three" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 analyzes live consumer data to identify trends,
                preferences, and purchasing behavior. It provides actionable
                insights that help businesses tailor their marketing strategies,
                product development, and sales efforts to better meet consumer
                needs.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="four">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "four" ? "" : "four")}
            >
              <div className="off-black extra-large bold">
                Is Regul8 customizable to specific business needs?
              </div>

              {open == "four" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "four" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Absolutely. Regul8 offers customization options to fit the
                unique needs of different CPG businesses. It provides a seamless
                solution that aligns with your organizational goals.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="five">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "five" ? "" : "five")}
            >
              <div className="off-black extra-large bold">
                What types of reports can Regul8 generate?{" "}
              </div>

              {open == "five" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "five" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                The software can generate a variety of reports, including
                compliance status, risk assessments, supply chain performance,
                sales analytics, and consumer behavior insights. Reports are
                customizable and can be automated for regular updates.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="six">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "six" ? "" : "six")}
            >
              <div className="off-black extra-large bold">
                How does the AI in Regul8 help with risk management?
              </div>

              {open == "six" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "six" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 uses machine learning algorithms to identify potential
                risks in compliance, supply chain, and operations. It provides
                predictive insights and proactive risk mitigation strategies to
                help businesses avoid disruptions.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="seven">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "seven" ? "" : "seven")}
            >
              <div className="off-black extra-large bold">
                What support and training are provided when implementing Regul8?
              </div>

              {open == "seven" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "seven" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 offers comprehensive support and training for new users,
                including onboarding sessions, user guides, and 24/7 customer
                support to ensure a smooth implementation and ongoing usability
                of the platform.{" "}
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={`tab-pane fade faq-section ${
            active == "pills-support-tab" ? "show active" : ""
          }`}
          id="pills-support"
          role="tabpanel"
          aria-labelledby="pills-support-tab"
        >
          <div for="one">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "one" ? "" : "one")}
            >
              <div className="off-black extra-large bold">
                What is Regul8, and how does it benefit CPG businesses?
              </div>

              {open == "one" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "one" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low ">
                Regul8 is a software platform that leverages artificial
                intelligence to help CPG companies optimize their operations,
                manage regulatory compliance, and make data-driven decisions. It
                enhances supply chain efficiency, reduces costs, and improves
                responsiveness to market changes.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="two">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "two" ? "" : "two")}
            >
              <div className="off-black extra-large bold">
                How does Regul8 help with regulatory compliance in multiple
                markets?
              </div>

              {open == "two" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "two" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 monitors and analyzes regulatory changes across various
                markets and regions, providing real-time updates and automated
                alerts. It ensures your business remains compliant by tracking
                new requirements and streamlining compliance management
                processes.{" "}
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="three">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "three" ? "" : "three")}
            >
              <div className="off-black extra-large bold">
                What kind of consumer insights does Regul8 provide?
              </div>

              {open == "three" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "three" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 analyzes live consumer data to identify trends,
                preferences, and purchasing behavior. It provides actionable
                insights that help businesses tailor their marketing strategies,
                product development, and sales efforts to better meet consumer
                needs.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="four">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "four" ? "" : "four")}
            >
              <div className="off-black extra-large bold">
                Is Regul8 customizable to specific business needs?
              </div>

              {open == "four" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "four" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Absolutely. Regul8 offers customization options to fit the
                unique needs of different CPG businesses. It provides a seamless
                solution that aligns with your organizational goals.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="five">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "five" ? "" : "five")}
            >
              <div className="off-black extra-large bold">
                What types of reports can Regul8 generate?{" "}
              </div>

              {open == "five" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "five" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                The software can generate a variety of reports, including
                compliance status, risk assessments, supply chain performance,
                sales analytics, and consumer behavior insights. Reports are
                customizable and can be automated for regular updates.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="six">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "six" ? "" : "six")}
            >
              <div className="off-black extra-large bold">
                How does the AI in Regul8 help with risk management?
              </div>

              {open == "six" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "six" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 uses machine learning algorithms to identify potential
                risks in compliance, supply chain, and operations. It provides
                predictive insights and proactive risk mitigation strategies to
                help businesses avoid disruptions.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="seven">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "seven" ? "" : "seven")}
            >
              <div className="off-black extra-large bold">
                What support and training are provided when implementing Regul8?
              </div>

              {open == "seven" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "seven" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 offers comprehensive support and training for new users,
                including onboarding sessions, user guides, and 24/7 customer
                support to ensure a smooth implementation and ongoing usability
                of the platform.{" "}
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={`tab-pane fade faq-section ${
            active == "pills-security-tab" ? "show active" : ""
          }`}
          id="pills-security"
          role="tabpanel"
          aria-labelledby="pills-security-tab"
        >
          <div for="one">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "one" ? "" : "one")}
            >
              <div className="off-black extra-large bold">
                What is Regul8, and how does it benefit CPG businesses?
              </div>

              {open == "one" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "one" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 is a software platform that leverages artificial
                intelligence to help CPG companies optimize their operations,
                manage regulatory compliance, and make data-driven decisions. It
                enhances supply chain efficiency, reduces costs, and improves
                responsiveness to market changes.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="two">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "two" ? "" : "two")}
            >
              <div className="off-black extra-large bold">
                How does Regul8 help with regulatory compliance in multiple
                markets?
              </div>

              {open == "two" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "two" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 monitors and analyzes regulatory changes across various
                markets and regions, providing real-time updates and automated
                alerts. It ensures your business remains compliant by tracking
                new requirements and streamlining compliance management
                processes.{" "}
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="three">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "three" ? "" : "three")}
            >
              <div className="off-black extra-large bold">
                What kind of consumer insights does Regul8 provide?
              </div>

              {open == "three" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "three" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 analyzes live consumer data to identify trends,
                preferences, and purchasing behavior. It provides actionable
                insights that help businesses tailor their marketing strategies,
                product development, and sales efforts to better meet consumer
                needs.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="four">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "four" ? "" : "four")}
            >
              <div className="off-black extra-large bold">
                Is Regul8 customizable to specific business needs?
              </div>

              {open == "four" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "four" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Absolutely. Regul8 offers customization options to fit the
                unique needs of different CPG businesses. It provides a seamless
                solution that aligns with your organizational goals.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="five">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "five" ? "" : "five")}
            >
              <div className="off-black extra-large bold">
                What types of reports can Regul8 generate?{" "}
              </div>

              {open == "five" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "five" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low ">
                The software can generate a variety of reports, including
                compliance status, risk assessments, supply chain performance,
                sales analytics, and consumer behavior insights. Reports are
                customizable and can be automated for regular updates.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="six">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "six" ? "" : "six")}
            >
              <div className="off-black extra-large bold">
                How does the AI in Regul8 help with risk management?
              </div>

              {open == "six" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "six" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 uses machine learning algorithms to identify potential
                risks in compliance, supply chain, and operations. It provides
                predictive insights and proactive risk mitigation strategies to
                help businesses avoid disruptions.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="seven">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "seven" ? "" : "seven")}
            >
              <div className="off-black extra-large bold">
                What support and training are provided when implementing Regul8?
              </div>

              {open == "seven" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "seven" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 offers comprehensive support and training for new users,
                including onboarding sessions, user guides, and 24/7 customer
                support to ensure a smooth implementation and ongoing usability
                of the platform.{" "}
              </div>
            ) : null}
          </div>
        </div>
        <div
          className={`tab-pane fade faq-section ${
            active == "pills-questions-tab" ? "show active" : ""
          }`}
          id="pills-questions"
          role="tabpanel"
          aria-labelledby="pills-questions-tab"
        >
          <div for="one">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "one" ? "" : "one")}
            >
              <div className="off-black extra-large bold">
                What is Regul8, and how does it benefit CPG businesses?
              </div>

              {open == "one" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "one" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 is a software platform that leverages artificial
                intelligence to help CPG companies optimize their operations,
                manage regulatory compliance, and make data-driven decisions. It
                enhances supply chain efficiency, reduces costs, and improves
                responsiveness to market changes.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="two">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "two" ? "" : "two")}
            >
              <div className="off-black extra-large bold">
                How does Regul8 help with regulatory compliance in multiple
                markets?
              </div>

              {open == "two" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "two" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 monitors and analyzes regulatory changes across various
                markets and regions, providing real-time updates and automated
                alerts. It ensures your business remains compliant by tracking
                new requirements and streamlining compliance management
                processes.{" "}
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="three">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "three" ? "" : "three")}
            >
              <div className="off-black extra-large bold">
                What kind of consumer insights does Regul8 provide?
              </div>

              {open == "three" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "three" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 analyzes live consumer data to identify trends,
                preferences, and purchasing behavior. It provides actionable
                insights that help businesses tailor their marketing strategies,
                product development, and sales efforts to better meet consumer
                needs.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="four">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "four" ? "" : "four")}
            >
              <div className="off-black extra-large bold">
                Is Regul8 customizable to specific business needs?
              </div>

              {open == "four" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "four" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Absolutely. Regul8 offers customization options to fit the
                unique needs of different CPG businesses. It provides a seamless
                solution that aligns with your organizational goals.
              </div>
            ) : null}
          </div>
          <div className=" line mt-4 mb-4" />
          <div for="five">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "five" ? "" : "five")}
            >
              <div className="off-black extra-large bold">
                What types of reports can Regul8 generate?{" "}
              </div>

              {open == "five" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "five" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                The software can generate a variety of reports, including
                compliance status, risk assessments, supply chain performance,
                sales analytics, and consumer behavior insights. Reports are
                customizable and can be automated for regular updates.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="six">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "six" ? "" : "six")}
            >
              <div className="off-black extra-large bold">
                How does the AI in Regul8 help with risk management?
              </div>

              {open == "six" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "six" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 uses machine learning algorithms to identify potential
                risks in compliance, supply chain, and operations. It provides
                predictive insights and proactive risk mitigation strategies to
                help businesses avoid disruptions.{" "}
              </div>
            ) : null}
          </div>

          <div className=" line mt-4 mb-4" />
          <div for="seven">
            <div
              className="d-flex justify-content-between gap-5 w-100 pointer"
              onClick={() => setOpen(open == "seven" ? "" : "seven")}
            >
              <div className="off-black extra-large bold">
                What support and training are provided when implementing Regul8?
              </div>

              {open == "seven" ? (
                <div className="up">
                  <img src={up} alt="up" style={{ width: "0.87106rem" }} />
                </div>
              ) : (
                <div className="down">
                  <img
                    src={down}
                    alt="down"
                    style={{ width: "0.87106rem", cursor: "pointer" }}
                  />
                </div>
              )}
            </div>
            {open == "seven" ? (
              <div className="right-5 off-black large normal mt-3 opacity-low">
                Regul8 offers comprehensive support and training for new users,
                including onboarding sessions, user guides, and 24/7 customer
                support to ensure a smooth implementation and ongoing usability
                of the platform.{" "}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
